export default __webpack_public_path__ + "static/media/rotate-phone.d68df9bf.svg";